export enum AccordionListItemViewStates {
  Expanded = 'simx-expanded',
  Collapsed = 'simx-collapsed',
}
